
import { z } from "zod";

export const OrganizationTypeValues = ["CONTRACTOR", "FUNDING", "HOMEOWNER", "REMI_INTERNAL", "SOLAR_COMPANY", "VENDOR"] as const;
export const OrganizationTypeSchema = z.enum(OrganizationTypeValues);
export const OrganizationType = OrganizationTypeSchema.enum;
export type OrganizationType = (typeof OrganizationTypeValues)[number];
export const OrganizationTypeDisplayNames = { "CONTRACTOR": "Contractor",
"FUNDING": "Funding",
"HOMEOWNER": "Homeowner",
"REMI_INTERNAL": "Remi",
"SOLAR_COMPANY": "Partner",
"VENDOR": "Vendor", } satisfies Record<OrganizationType, string>;
